import { render, staticRenderFns } from "./VideoCourseChapter.vue?vue&type=template&id=0f01ec76&scoped=true&"
import script from "./VideoCourseChapter.vue?vue&type=script&lang=js&"
export * from "./VideoCourseChapter.vue?vue&type=script&lang=js&"
import style0 from "./VideoCourseChapter.vue?vue&type=style&index=0&id=0f01ec76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01ec76",
  null
  
)

export default component.exports